import React, { Component } from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';

import Scriba from 'react-scriba';

import 'react-vertical-timeline-component/style.min.css';
import './TimelineVerticale.css';

/****************************************************************
 PROPS:
    listeActions
****************************************************************/

var objetState = {
    listeActions: []
};

export class TimelineVerticale extends Component {
    _creationContent() {
        let contenu = [];

        this.state.listeActions.forEach(function (action) {
            contenu.push(<VerticalTimelineElement
                className={`vertical-timeline-element--${action.categorie}`}
                date={Scriba.date().stringDateHeureFormatCourt(action.dateAction)}
                iconStyle={{ background: action.codeHexaIcone, color: '#fff' }}
                icon={<Icon iconName={action.nomIcone} />}>
                <div className="vertical-timeline-element-title">{action.titre}</div>
                <div className="vertical-timeline-element-subtitle">Le {Scriba.date().stringDateFormat(action.dateAction, 'LLL')}</div>
                <p>{action.corps}</p>
            </VerticalTimelineElement>)
        });

        return (<VerticalTimeline>{contenu}</VerticalTimeline>);
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    componentDidMount() {
        this.setState({ listeActions: this.props.listeActions });
    }

    componentDidUpdate() {
        if (this.props.listeActions !== this.state.listeActions) {
            this.setState({ listeActions: this.props.listeActions });
        }
    }

    componentWillUnmount() {
    }

    render() {
        let content = this._creationContent();

        return (<div className="innerBackground">{content}</div>);
    }
}